window.$ = window.jQuery = require('jquery');

require('slick-carousel');
require('jquery.scrollto');
